/**
 * Artist profile works: complete the grid, then filter by collection + tags.
 */
(function () {
  var page = document.querySelector(".artist-page");
  if (page) {
    var hero = page.querySelector(".artist-hero");
    var works = page.querySelector("[data-artist-works]");
    var copy = page.querySelector(".artist-copy");
    if (hero && works && works.parentElement !== page) hero.after(works);
    if (works && copy && copy.parentElement !== page) works.after(copy);
    initArtistSceneCarousel(page);
  }

  function foldArtistName(value) {
    return String(value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function handleizeArtistName(value) {
    return foldArtistName(value).replace(/\s+/g, "-");
  }

  function sameArtistName(vendor, name, slug) {
    if (!vendor) return false;
    var vendorFold = foldArtistName(vendor);
    var vendorHandle = handleizeArtistName(vendor);
    if (name && (vendorFold === foldArtistName(name) || vendorHandle === handleizeArtistName(name))) return true;
    if (slug && (vendorHandle === handleizeArtistName(slug) || vendorHandle === String(slug).toLowerCase())) return true;
    return false;
  }

  function catalogScenesForArtist(root) {
    var works = root.querySelector("[data-artist-works]");
    var vendor = (works && works.getAttribute("data-artist-vendor")) || "";
    var slug = (works && works.getAttribute("data-artist-slug")) || "";
    var heading = root.querySelector(".artist-intro h1");
    var name = vendor || ((heading && heading.textContent) || "").trim();
    var catalogEl = root.querySelector("[data-lifestyle-scene-catalog]");
    var catalog = [];
    try {
      catalog = catalogEl ? JSON.parse(catalogEl.textContent || "[]") : [];
    } catch (e) {
      catalog = [];
    }
    if (!Array.isArray(catalog)) return [];
    var slides = [];
    var seen = {};
    catalog.forEach(function (item) {
      if (!item || !sameArtistName(item.vendor, name, slug)) return;
      var href = item.url || (item.handle ? "/products/" + item.handle : "");
      var title = item.title || "";
      (item.scenes || []).forEach(function (scene) {
        var src = scene && (scene.src || scene.url);
        if (!src || seen[src]) return;
        seen[src] = 1;
        slides.push({ src: src, href: href, title: title });
      });
    });
    return slides.slice(0, 8);
  }

  function appendSceneName(slide, title) {
    var label = String(title || "").trim();
    if (!label || slide.querySelector(".artist-scene-name")) return;
    var name = document.createElement("span");
    name.className = "artist-scene-name";
    name.textContent = label;
    slide.appendChild(name);
  }

  function ensureArtistSceneCarousel(root, pool) {
    var carousel = root.querySelector("[data-artist-scene-carousel]");
    if (carousel || !pool.length) return carousel;
    var heroInner = root.querySelector(".artist-hero-inner") || root.querySelector(".artist-hero");
    if (!heroInner) return null;
    var portrait = root.querySelector(".artist-portrait");
    if (!portrait) {
      portrait = document.createElement("div");
      portrait.className = "artist-portrait artist-portrait--scenes";
      heroInner.insertBefore(portrait, heroInner.firstChild);
    } else {
      portrait.classList.add("artist-portrait--scenes");
      portrait.innerHTML = "";
    }
    carousel = document.createElement("div");
    carousel.className = "artist-scene-carousel";
    carousel.setAttribute("data-artist-scene-carousel", "");
    carousel.setAttribute("aria-label", "Prints in rooms");
    var first = document.createElement("a");
    first.className = "artist-scene-slide is-on";
    first.href = pool[0].href || "#";
    var img = document.createElement("img");
    img.src = pool[0].src;
    img.alt = (pool[0].title || "") + " hanging in a room";
    img.width = 900;
    img.height = 900;
    first.appendChild(img);
    appendSceneName(first, pool[0].title);
    carousel.appendChild(first);
    if (pool.length > 1) {
      var prev = document.createElement("button");
      prev.type = "button";
      prev.className = "artist-scene-nav artist-scene-nav--prev";
      prev.setAttribute("data-artist-scene-prev", "");
      prev.setAttribute("aria-label", "Previous room photograph");
      prev.textContent = "‹";
      var next = document.createElement("button");
      next.type = "button";
      next.className = "artist-scene-nav artist-scene-nav--next";
      next.setAttribute("data-artist-scene-next", "");
      next.setAttribute("aria-label", "Next room photograph");
      next.textContent = "›";
      carousel.appendChild(prev);
      carousel.appendChild(next);
    }
    portrait.appendChild(carousel);
    return carousel;
  }

  function initArtistSceneCarousel(root) {
    var poolEl = root.querySelector("[data-artist-scenes-pool]");
    var pool = [];
    try {
      pool = poolEl ? JSON.parse(poolEl.textContent || "[]") : [];
    } catch (e) {
      pool = [];
    }
    if (!Array.isArray(pool)) pool = [];
    catalogScenesForArtist(root).forEach(function (item) {
      pool.push(item);
    });
    var carousel = root.querySelector("[data-artist-scene-carousel]");
    if (!carousel) carousel = ensureArtistSceneCarousel(root, pool);
    if (!carousel) return;
    var firstImg = carousel.querySelector(".artist-scene-slide img");
    var firstSrc = firstImg ? firstImg.getAttribute("src") : "";
    var seen = {};
    if (firstSrc) seen[firstSrc] = 1;
    pool.forEach(function (item) {
      if (!item || !item.src || seen[item.src]) return;
      seen[item.src] = 1;
      var slide = document.createElement("a");
      slide.className = "artist-scene-slide";
      slide.href = item.href || "#";
      var img = document.createElement("img");
      img.src = item.src;
      img.alt = (item.title || "") + " hanging in a room";
      img.width = 900;
      img.height = 900;
      img.loading = "lazy";
      slide.appendChild(img);
      appendSceneName(slide, item.title);
      var nav = carousel.querySelector(".artist-scene-nav");
      if (nav) carousel.insertBefore(slide, nav);
      else carousel.appendChild(slide);
    });
    if (!carousel.querySelector("[data-artist-scene-prev]") && carousel.querySelectorAll(".artist-scene-slide").length > 1) {
      var prevBtn = document.createElement("button");
      prevBtn.type = "button";
      prevBtn.className = "artist-scene-nav artist-scene-nav--prev";
      prevBtn.setAttribute("data-artist-scene-prev", "");
      prevBtn.setAttribute("aria-label", "Previous room photograph");
      prevBtn.textContent = "‹";
      var nextBtn = document.createElement("button");
      nextBtn.type = "button";
      nextBtn.className = "artist-scene-nav artist-scene-nav--next";
      nextBtn.setAttribute("data-artist-scene-next", "");
      nextBtn.setAttribute("aria-label", "Next room photograph");
      nextBtn.textContent = "›";
      carousel.appendChild(prevBtn);
      carousel.appendChild(nextBtn);
    }
    var slides = carousel.querySelectorAll(".artist-scene-slide");
    if (slides.length < 2) return;
    var index = 0;
    var timer = 0;
    var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function show(next) {
      index = (next + slides.length) % slides.length;
      Array.prototype.forEach.call(slides, function (el, i) {
        el.classList.toggle("is-on", i === index);
      });
    }
    function stop() {
      if (timer) window.clearInterval(timer);
      timer = 0;
    }
    function start() {
      if (reduced) return;
      stop();
      timer = window.setInterval(function () {
        show(index + 1);
      }, 5200);
    }
    var prev = carousel.querySelector("[data-artist-scene-prev]");
    var next = carousel.querySelector("[data-artist-scene-next]");
    if (prev) {
      prev.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        show(index - 1);
        start();
      });
    }
    if (next) {
      next.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        show(index + 1);
        start();
      });
    }
    carousel.addEventListener("mouseenter", stop);
    carousel.addEventListener("mouseleave", start);
    carousel.addEventListener("focusin", stop);
    carousel.addEventListener("focusout", start);
    start();
  }

  var root = document.querySelector("[data-artist-works]");
  if (!root) return;

  var grid = root.querySelector("[data-artist-works-grid]");
  if (!grid) return;

  function filterPanelHtml() {
    return (
      '<div class="artist-filter-panel" data-artist-filter-panel hidden>' +
      '<label class="artist-filter-search">' +
      '<input type="search" data-artist-filter-query placeholder="Search works" autocomplete="off" enterkeyhint="search" aria-label="Search this artist\'s works">' +
      "</label>" +
      '<div class="artist-cloud" data-artist-genre-cloud hidden>' +
      '<span class="eyebrow artist-cloud-label">Collections</span>' +
      '<div class="artist-chips" data-artist-genre-chips role="group" aria-label="Filter works by collection">' +
      '<button type="button" class="artist-chip is-active" data-artist-genre="" aria-pressed="true">All</button>' +
      "</div></div>" +
      '<div class="artist-cloud" data-artist-tag-cloud hidden>' +
      '<span class="eyebrow artist-cloud-label">In their work</span>' +
      '<div class="artist-chips" data-artist-tag-chips role="group" aria-label="Filter works by tag">' +
      '<button type="button" class="artist-chip is-active" data-artist-tag="" aria-pressed="true">All</button>' +
      "</div></div></div>"
    );
  }

  function ensureFilterToggle(head) {
    if (root.querySelector("[data-artist-filter-toggle]")) return;
    var tools = head.querySelector(".artist-works-tools");
    if (!tools) {
      tools = document.createElement("div");
      tools.className = "artist-works-tools";
      var count = head.querySelector("[data-artist-works-count]");
      if (count) tools.appendChild(count);
      head.appendChild(tools);
    }
    var toggle = document.createElement("button");
    toggle.type = "button";
    toggle.className = "artist-filter-toggle";
    toggle.setAttribute("data-artist-filter-toggle", "");
    toggle.setAttribute("aria-expanded", "false");
    toggle.textContent = "Filter";
    tools.appendChild(toggle);
  }

  function ensureFilterDom() {
    var head = root.querySelector(".artist-works-head");
    if (!head) {
      head = document.createElement("div");
      head.className = "artist-works-head";
      var label = root.querySelector(".artist-works-label");
      if (label) head.appendChild(label);
      var count = document.createElement("p");
      count.className = "artist-works-count";
      count.setAttribute("data-artist-works-count", "");
      head.appendChild(count);
      root.insertBefore(head, grid);
    }
    ensureFilterToggle(head);
    var filters = root.querySelector("[data-artist-filters]");
    if (!filters) {
      filters = document.createElement("div");
      filters.className = "artist-filters";
      filters.setAttribute("data-artist-filters", "");
      filters.hidden = true;
      filters.innerHTML = filterPanelHtml();
      var anchor = root.querySelector("[data-artist-filter-empty]") || grid;
      anchor.parentNode.insertBefore(filters, anchor);
    } else if (!filters.querySelector("[data-artist-filter-panel]")) {
      var panel = document.createElement("div");
      panel.className = "artist-filter-panel";
      panel.setAttribute("data-artist-filter-panel", "");
      panel.hidden = true;
      var search = document.createElement("label");
      search.className = "artist-filter-search";
      search.innerHTML =
        '<input type="search" data-artist-filter-query placeholder="Search works" autocomplete="off" enterkeyhint="search" aria-label="Search this artist\'s works">';
      panel.appendChild(search);
      while (filters.firstChild) panel.appendChild(filters.firstChild);
      filters.appendChild(panel);
    }
    if (!root.querySelector("[data-artist-filter-empty]")) {
      var empty = document.createElement("p");
      empty.className = "artist-filter-empty";
      empty.setAttribute("data-artist-filter-empty", "");
      empty.hidden = true;
      empty.innerHTML =
        'No works match this filter. <button type="button" class="dir-empty-reset" data-artist-filter-clear>Clear filters</button>';
      grid.parentNode.insertBefore(empty, grid);
    }
  }

  ensureFilterDom();

  var filtersEl = root.querySelector("[data-artist-filters]");
  var filterToggle = root.querySelector("[data-artist-filter-toggle]");
  var filterPanel = root.querySelector("[data-artist-filter-panel]");
  var filterQuery = root.querySelector("[data-artist-filter-query]");
  var genreCloud = root.querySelector("[data-artist-genre-cloud]");
  var tagCloud = root.querySelector("[data-artist-tag-cloud]");
  var genreChips = root.querySelector("[data-artist-genre-chips]");
  var tagChips = root.querySelector("[data-artist-tag-chips]");
  var countEl = root.querySelector("[data-artist-works-count]");
  var emptyEl = root.querySelector("[data-artist-filter-empty]");
  var clearBtn = root.querySelector("[data-artist-filter-clear]");

  var vendor = (root.getAttribute("data-artist-vendor") || "").trim();
  var artistSlug = (root.getAttribute("data-artist-slug") || "").trim().toLowerCase();
  var worksTotal = parseInt(root.getAttribute("data-artist-works-total") || "0", 10) || 0;
  var pagedListing = root.getAttribute("data-artist-works-paged") === "true";
  var hang = root.querySelector("[data-artist-hang]");
  var pinnedHandles = [];
  var packTimer = 0;
  var packBound = false;
  var packedCols = 0;
  var activeGenre = "";
  var activeTag = "";
  var activeQuery = "";
  var filterOpen = false;
  var genreMembers = {};
  var genreFetch = {};
  var SKIP_TAGS = {
    "1x": 1,
    "2x": 1,
    print: 1,
    prints: 1,
    framed: 1,
    frame: 1,
    new: 1,
    sale: 1,
    art: 1,
    artwork: 1,
    baw: 1,
    "black-wite": 1,
    square: 1,
    ny: 1,
    featured: 1,
    bestseller: 1
  };

  function norm(s) {
    return String(s || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function handleize(s) {
    return norm(s).replace(/\s+/g, "-");
  }

  function sameVendor(a, b) {
    if (!a || !b) return false;
    return norm(a) === norm(b) || handleize(a) === handleize(b);
  }

  function formatMoney(cents) {
    if (cents == null || !isFinite(Number(cents))) return "";
    if (window.theme && typeof window.theme.formatMoney === "function") {
      return window.theme.formatMoney(Number(cents));
    }
    return "£" + (Number(cents) / 100).toFixed(2);
  }

  function priceCents(product) {
    var raw =
      product.price_min != null
        ? product.price_min
        : product.price != null
          ? product.price
          : product.variants && product.variants[0]
            ? product.variants[0].price
            : null;
    if (raw == null || raw === "") return null;
    var str = String(raw);
    if (str.indexOf(".") !== -1) return Math.round(parseFloat(str) * 100);
    var n = Number(str);
    if (!isFinite(n)) return null;
    return n < 1000 ? Math.round(n * 100) : n;
  }

  function imageMeta(product) {
    var img =
      (product && product.featured_image) ||
      (product && product.image) ||
      (product && product.images && product.images[0]);
    if (!img) return { src: "", width: 0, height: 0 };
    if (typeof img === "string") return { src: img, width: 0, height: 0 };
    return {
      src: img.url || img.src || "",
      width: Number(img.width) || 0,
      height: Number(img.height) || 0
    };
  }

  function imageUrl(product) {
    var src = imageMeta(product).src;
    if (!src) return "";
    if (src.indexOf("cdn.shopify.com") !== -1 && src.indexOf("width=") === -1) {
      return src + (src.indexOf("?") === -1 ? "?" : "&") + "width=700";
    }
    return src;
  }

  function productHandle(product) {
    if (product.handle) return product.handle;
    if (product.url) {
      var m = String(product.url).match(/\/products\/([^/?#]+)/);
      if (m) return m[1];
    }
    return "";
  }

  function skipTag(handle) {
    if (!handle || SKIP_TAGS[handle]) return true;
    if (/^\d+$/.test(handle)) return true;
    if (handle.indexOf("cm") !== -1 || handle.indexOf("mount") !== -1) return true;
    if (/^\d+x\d+/.test(handle)) return true;
    return false;
  }

  function productTags(product) {
    var tags = product && product.tags;
    if (!tags) return [];
    if (typeof tags === "string") tags = tags.split(",");
    if (!Array.isArray(tags)) return [];
    return tags
      .map(function (tag) {
        return handleize(tag);
      })
      .filter(function (handle) {
        return handle && !skipTag(handle);
      });
  }

  function labelize(handle) {
    return String(handle || "")
      .replace(/-/g, " ")
      .replace(/\b\w/g, function (ch) {
        return ch.toUpperCase();
      });
  }

  function usesCollectionGrid() {
    return !!(grid && grid.classList.contains("masonry"));
  }

  function cards() {
    var selector = usesCollectionGrid() ? ".mcard" : ".card";
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function cardHandle(card) {
    return (card.getAttribute("data-work-handle") || "").toLowerCase();
  }

  function proxyPath() {
    var path = (window.theme && window.theme.followProxyPath) || "/apps/artfolio";
    return String(path).replace(/\/$/, "");
  }

  function pinList() {
    var pins = [];
    var seen = {};
    pinnedHandles.forEach(function (handle) {
      handle = String(handle || "").toLowerCase();
      if (!handle || seen[handle]) return;
      seen[handle] = 1;
      pins.push(handle);
    });
    return pins.slice(0, 3);
  }

  function columnCount() {
    return window.matchMedia("(max-width: 1000px)").matches ? 2 : 4;
  }

  function ensureBin() {
    var bin = root.querySelector("[data-artist-bin]");
    if (bin) return bin;
    bin = document.createElement("div");
    bin.className = "artist-masonry-bin";
    bin.setAttribute("data-artist-bin", "");
    bin.hidden = true;
    root.appendChild(bin);
    return bin;
  }

  function uniqueCards() {
    var unique = [];
    var have = {};
    cards().forEach(function (card) {
      var handle = cardHandle(card);
      if (!handle || have[handle]) return;
      have[handle] = 1;
      unique.push(card);
    });
    return unique;
  }

  function flattenMasonry() {
    if (!grid) return;
    if (!grid.getAttribute("data-packed") && !grid.querySelector("[data-artist-col]")) return;
    var selector = usesCollectionGrid() ? ".mcard" : ".card";
    Array.prototype.forEach.call(grid.querySelectorAll(selector), function (card) {
      grid.appendChild(card);
    });
    Array.prototype.forEach.call(grid.querySelectorAll("[data-artist-col]"), function (col) {
      col.remove();
    });
    grid.removeAttribute("data-packed");
  }

  function ensureColumns(count) {
    var cols = grid.querySelectorAll("[data-artist-col]");
    if (cols.length === count && grid.getAttribute("data-packed") === "1") {
      return cols;
    }
    flattenMasonry();
    for (var i = 0; i < count; i += 1) {
      var col = document.createElement("div");
      col.className = "artist-masonry-col";
      col.setAttribute("data-artist-col", "");
      grid.appendChild(col);
    }
    grid.setAttribute("data-packed", "1");
    return grid.querySelectorAll("[data-artist-col]");
  }

  function shortestColumn(cols) {
    var best = cols[0];
    var min = best ? best.offsetHeight : 0;
    Array.prototype.forEach.call(cols, function (col) {
      var height = col.offsetHeight;
      if (height < min) {
        min = height;
        best = col;
      }
    });
    return best;
  }

  function schedulePack() {
    if (columnCount() === packedCols && grid && grid.getAttribute("data-packed") === "1") return;
    if (packTimer) cancelAnimationFrame(packTimer);
    packTimer = requestAnimationFrame(function () {
      packTimer = 0;
      applyHang();
    });
  }

  function bindPackListeners() {
    if (packBound) return;
    packBound = true;
    window.addEventListener("resize", schedulePack);
    if (window.matchMedia) {
      var mq = window.matchMedia("(max-width: 1000px)");
      if (mq.addEventListener) mq.addEventListener("change", schedulePack);
      else if (mq.addListener) mq.addListener(schedulePack);
    }
  }

  function applyHang() {
    if (!grid) return;
    var pins = pinList();
    var unique = uniqueCards();
    var pinSet = {};
    pins.forEach(function (handle) {
      pinSet[handle] = 1;
    });
    var visiblePins = [];
    var rest = [];
    var bin = ensureBin();
    unique.forEach(function (card) {
      if (card.hidden || card.classList.contains("is-dir-hidden")) {
        bin.appendChild(card);
        return;
      }
      if (pinSet[cardHandle(card)]) visiblePins.push(card);
      else rest.push(card);
    });
    visiblePins.sort(function (a, b) {
      return pins.indexOf(cardHandle(a)) - pins.indexOf(cardHandle(b));
    });

    if (usesCollectionGrid()) {
      if (hang) {
        hang.hidden = !visiblePins.length;
        hang.setAttribute("data-count", String(visiblePins.length));
      }
      visiblePins.concat(rest).forEach(function (card) {
        grid.appendChild(card);
      });
      return;
    }

    if (hang) {
      hang.hidden = !visiblePins.length;
      hang.setAttribute("data-count", String(visiblePins.length));
    }

    var cols = ensureColumns(columnCount());
    packedCols = cols.length;
    var park = document.createDocumentFragment();
    visiblePins.forEach(function (card) {
      park.appendChild(card);
    });
    rest.forEach(function (card) {
      park.appendChild(card);
    });
    visiblePins.forEach(function (card, index) {
      cols[index % cols.length].appendChild(card);
    });
    rest.forEach(function (card) {
      shortestColumn(cols).appendChild(card);
    });
    bindPackListeners();
  }

  function fetchPins() {
    if (!artistSlug) return Promise.resolve([]);
    return fetch(proxyPath() + "/studio?hang=1&slug=" + encodeURIComponent(artistSlug), {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    })
      .then(function (res) {
        if (!res.ok) return [];
        return res.json();
      })
      .then(function (data) {
        return Array.isArray(data && data.pinned) ? data.pinned : [];
      })
      .catch(function () {
        return [];
      });
  }

  function readParams() {
    try {
      var sp = new URLSearchParams(window.location.search);
      return { genre: (sp.get("genre") || "").trim(), tag: (sp.get("tag") || "").trim() };
    } catch (e) {
      return { genre: "", tag: "" };
    }
  }

  function writeParams() {
    try {
      var url = new URL(window.location.href);
      if (activeGenre) url.searchParams.set("genre", activeGenre);
      else url.searchParams.delete("genre");
      if (activeTag) url.searchParams.set("tag", activeTag);
      else url.searchParams.delete("tag");
      window.history.replaceState({}, "", url.pathname + url.search + url.hash);
    } catch (e) {}
  }

  function setChipState(wrap, attr, value) {
    if (!wrap) return;
    wrap.querySelectorAll("[" + attr + "]").forEach(function (btn) {
      var on = (btn.getAttribute(attr) || "") === value;
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  function cardList(el, attr) {
    return String(el.getAttribute(attr) || "")
      .toLowerCase()
      .split(/\s+/)
      .filter(Boolean);
  }

  function cardMatches(card) {
    var genres = cardList(card, "data-work-genres");
    var tags = cardList(card, "data-work-tags");
    var handle = card.getAttribute("data-work-handle") || "";
    var matchG = true;
    if (activeGenre) {
      matchG = genres.indexOf(activeGenre.toLowerCase()) !== -1;
      if (!matchG && genreMembers[activeGenre] && handle) {
        matchG = !!genreMembers[activeGenre][handle];
      }
    }
    var matchT = !activeTag || tags.indexOf(activeTag.toLowerCase()) !== -1;
    if (!matchG || !matchT) return false;
    if (!activeQuery) return true;
    var titleEl = card.querySelector(".card-meta .t, .t");
    var title = norm(card.getAttribute("data-work-title") || (titleEl ? titleEl.textContent : ""));
    return title.indexOf(norm(activeQuery)) !== -1;
  }

  function setFilterOpen(open, focusSearch) {
    filterOpen = !!open;
    if (filterPanel) filterPanel.hidden = !filterOpen;
    if (filtersEl) filtersEl.hidden = !filterOpen;
    if (filterToggle) filterToggle.setAttribute("aria-expanded", filterOpen ? "true" : "false");
    if (focusSearch && filterOpen && filterQuery) filterQuery.focus();
  }

  function paintToggle() {
    if (!filterToggle) return;
    var parts = [];
    if (activeQuery) parts.push(activeQuery);
    if (activeGenre) {
      var genreBtn = genreChips && genreChips.querySelector('[data-artist-genre="' + activeGenre.replace(/"/g, "") + '"]');
      parts.push(genreBtn ? genreBtn.textContent.trim() : labelize(activeGenre));
    }
    if (activeTag) parts.push(labelize(activeTag));
    filterToggle.textContent = parts.length ? "Filter · " + parts.join(" · ") : "Filter";
    filterToggle.classList.toggle("is-active", parts.length > 0);
  }

  function apply() {
    var list = cards();
    var shown = 0;
    list.forEach(function (card) {
      var show = cardMatches(card);
      card.hidden = !show;
      card.classList.toggle("is-dir-hidden", !show);
      if (show) shown += 1;
    });
    var total = list.length;
    if (countEl) {
      if (pagedListing && worksTotal) {
        if (activeGenre || activeTag || activeQuery) {
          countEl.textContent = shown + " match this filter";
        } else {
          countEl.textContent = worksTotal === 1 ? "1 work" : worksTotal + " works";
        }
      } else if (!total) {
        countEl.textContent = "";
      } else if (activeGenre || activeTag || activeQuery) {
        countEl.textContent = shown + " of " + total + " works";
      } else {
        countEl.textContent = total === 1 ? "1 work" : total + " works";
      }
    }
    if (emptyEl) emptyEl.hidden = !total || shown !== 0;
    setChipState(genreChips, "data-artist-genre", activeGenre);
    setChipState(tagChips, "data-artist-tag", activeTag);
    paintToggle();
    if (genreCloud) {
      genreCloud.querySelector(".artist-cloud-label") &&
        genreCloud.classList.toggle("is-active", !!activeGenre);
    }
    applyHang();
    writeParams();
  }

  function ensureChip(wrap, attr, value, label, weight) {
    if (!wrap || !value) return;
    var existing = wrap.querySelector("[" + attr + '="' + value.replace(/"/g, "") + '"]');
    if (existing) {
      if (weight) {
        existing.className = existing.className.replace(/artist-chip--w\d/g, "").trim();
        if (weight > 1) existing.classList.add("artist-chip--w" + weight);
      }
      return;
    }
    var allBtn = wrap.querySelector("[" + attr + '=""]');
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "artist-chip" + (weight > 1 ? " artist-chip--w" + weight : "");
    btn.setAttribute(attr, value);
    btn.setAttribute("aria-pressed", "false");
    btn.textContent = label || labelize(value);
    if (allBtn && allBtn.parentNode) allBtn.parentNode.appendChild(btn);
    else wrap.appendChild(btn);
  }

  function weightFor(count, max) {
    if (max <= 1 || count <= 1) return 1;
    var ratio = count / max;
    if (ratio >= 0.75) return 4;
    if (ratio >= 0.5) return 3;
    if (ratio >= 0.3) return 2;
    return 1;
  }

  function genreHandlesFromCopy() {
    var handles = {};
    document.querySelectorAll('.artist-copy a[href*="/collections/"]').forEach(function (a) {
      var m = String(a.getAttribute("href") || "").match(/\/collections\/([^/?#]+)/);
      if (!m) return;
      handles[m[1]] = a.textContent.trim() || labelize(m[1]);
    });
    return handles;
  }

  function rebuildFilters() {
    var tagCounts = {};
    var genreCounts = {};
    var genreLabels = genreHandlesFromCopy();
    if (genreChips) {
      genreChips.querySelectorAll("[data-artist-genre]").forEach(function (btn) {
        var handle = btn.getAttribute("data-artist-genre");
        if (handle) genreLabels[handle] = btn.textContent.trim();
      });
    }

    cards().forEach(function (card) {
      cardList(card, "data-work-tags").forEach(function (tag) {
        if (skipTag(tag) || genreLabels[tag]) return;
        tagCounts[tag] = (tagCounts[tag] || 0) + 1;
      });
      cardList(card, "data-work-genres").forEach(function (handle) {
        if (handle === "prints") return;
        genreCounts[handle] = (genreCounts[handle] || 0) + 1;
      });
    });

    var keepTags = {};
    var maxTag = 1;
    Object.keys(tagCounts).forEach(function (tag) {
      if (tagCounts[tag] > maxTag) maxTag = tagCounts[tag];
    });

    if (genreChips) {
      var printsBtn = genreChips.querySelector('[data-artist-genre="prints"]');
      if (printsBtn) printsBtn.hidden = true;
    }
    Object.keys(genreCounts).forEach(function (handle) {
      ensureChip(genreChips, "data-artist-genre", handle, genreLabels[handle] || labelize(handle));
    });
    Object.keys(tagCounts)
      .sort(function (a, b) {
        return tagCounts[b] - tagCounts[a] || a.localeCompare(b);
      })
      .slice(0, 18)
      .forEach(function (tag) {
        keepTags[tag] = true;
        ensureChip(tagChips, "data-artist-tag", tag, labelize(tag), weightFor(tagCounts[tag], maxTag));
      });
    if (tagChips) {
      tagChips.querySelectorAll("[data-artist-tag]").forEach(function (btn) {
        var handle = btn.getAttribute("data-artist-tag");
        if (handle) btn.hidden = !keepTags[handle];
      });
    }

    var genreCount = Object.keys(genreCounts).length;
    if (!genreCount && genreChips) {
      genreCount = Math.max(0, genreChips.querySelectorAll("[data-artist-genre]").length - 1);
    }
    var tagCount = Object.keys(keepTags).length;
    if (genreCloud) genreCloud.hidden = genreCount < 1;
    if (tagCloud) tagCloud.hidden = tagCount < 1;
    if (filterToggle) filterToggle.hidden = cards().length === 0;
    if (filtersEl) filtersEl.hidden = !filterOpen;
  }

  function stampCard(card, product) {
    var handle = productHandle(product);
    if (handle && !card.getAttribute("data-work-handle")) {
      card.setAttribute("data-work-handle", handle);
    }
    var tags = productTags(product).filter(function (tag) {
      return !skipTag(tag);
    });
    if (tags.length) {
      var current = cardList(card, "data-work-tags");
      tags.forEach(function (tag) {
        if (current.indexOf(tag) === -1) current.push(tag);
      });
      card.setAttribute("data-work-tags", current.join(" "));
    }
  }

  function renderCard(product) {
    var handle = productHandle(product);
    if (!handle) return null;
    var title = product.title || "Print";
    var artist = product.vendor || vendor;
    var type = product.product_type || product.type || "Print";
    var img = imageUrl(product);
    var cents = priceCents(product);

    var a = document.createElement("a");
    a.className = "card";
    a.href = "/products/" + handle;
    a.setAttribute("data-work-handle", handle);
    var tags = productTags(product);
    if (tags.length) a.setAttribute("data-work-tags", tags.join(" "));

    var ph = document.createElement("div");
    ph.className = img ? "ph" : "ph a a-oat";
    var imgMeta = imageMeta(product);
    if (imgMeta.width && imgMeta.height) {
      var ratio = imgMeta.width / imgMeta.height;
      ph.style.aspectRatio = String(ratio);
      if (ratio < 0.98) ph.classList.add("o-portrait");
      else if (ratio <= 1.05) ph.classList.add("o-square");
      else ph.classList.add("o-landscape");
    }
    if (img) {
      var imageEl = document.createElement("img");
      imageEl.src = img;
      imageEl.alt = title + " art print by " + artist;
      imageEl.loading = "lazy";
      imageEl.width = 700;
      ph.appendChild(imageEl);
    }
    a.appendChild(ph);

    var meta = document.createElement("div");
    meta.className = "m";
    meta.textContent = type;
    a.appendChild(meta);

    var t = document.createElement("div");
    t.className = "t";
    t.textContent = title;
    a.appendChild(t);

    if (artist) {
      var ar = document.createElement("div");
      ar.className = "ar";
      ar.textContent = artist;
      a.appendChild(ar);
    }

    if (cents != null) {
      var p = document.createElement("div");
      p.className = "p";
      p.textContent = "from " + formatMoney(cents);
      a.appendChild(p);
    }

    return a;
  }

  function mergeProducts(products) {
    var existing = {};
    cards().forEach(function (card) {
      var handle = card.getAttribute("data-work-handle") || "";
      if (!handle) {
        var m = String(card.getAttribute("href") || "").match(/\/products\/([^/?#]+)/);
        handle = m ? m[1] : "";
        if (handle) card.setAttribute("data-work-handle", handle);
      }
      if (handle) existing[handle] = card;
    });

    var frag = document.createDocumentFragment();
    products.forEach(function (product) {
      if (!product || !sameVendor(product.vendor, vendor)) return;
      var handle = productHandle(product);
      if (!handle) return;
      if (existing[handle]) {
        stampCard(existing[handle], product);
        return;
      }
      var card = renderCard(product);
      if (card) {
        frag.appendChild(card);
        existing[handle] = card;
      }
    });
    if (frag.childNodes.length) grid.appendChild(frag);
    if (cards().length) root.hidden = false;
  }

  function fetchSuggest() {
    var q = 'vendor:"' + vendor.replace(/"/g, "") + '"';
    var url =
      "/search/suggest.json?q=" +
      encodeURIComponent(q) +
      "&resources[type]=product&resources[limit]=50&resources[options][fields]=title,vendor,product_type,tag";
    return fetch(url, {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    })
      .then(function (res) {
        if (!res.ok) return [];
        return res.json();
      })
      .then(function (data) {
        return (data && data.resources && data.resources.results && data.resources.results.products) || [];
      })
      .catch(function () {
        return [];
      });
  }

  function fetchCatalogPages() {
    var all = [];
    var page = 1;
    var maxPages = 20;

    function next() {
      if (page > maxPages) return Promise.resolve(all);
      return fetch("/collections/all/products.json?limit=250&page=" + page, {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      })
        .then(function (res) {
          if (!res.ok) return [];
          return res.json();
        })
        .then(function (data) {
          var products = (data && data.products) || [];
          products.forEach(function (product) {
            if (sameVendor(product.vendor, vendor)) all.push(product);
          });
          if (!products.length || products.length < 250) return all;
          page += 1;
          return new Promise(function (resolve) {
            setTimeout(function () {
              resolve(next());
            }, 160);
          });
        })
        .catch(function () {
          return all;
        });
    }

    return next();
  }

  function fetchGenreMembers(handle) {
    if (!handle || genreMembers[handle] || genreFetch[handle]) {
      return Promise.resolve(genreMembers[handle] || {});
    }
    genreFetch[handle] = true;
    var map = {};
    var page = 1;
    var maxPages = 8;

    function next() {
      return fetch("/collections/" + encodeURIComponent(handle) + "/products.json?limit=250&page=" + page, {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      })
        .then(function (res) {
          if (!res.ok) return map;
          return res.json().then(function (data) {
            var products = (data && data.products) || [];
            products.forEach(function (product) {
              var ph = productHandle(product);
              if (ph && sameVendor(product.vendor, vendor)) map[ph] = true;
            });
            if (!products.length || products.length < 250 || page >= maxPages) return map;
            page += 1;
            return next();
          });
        })
        .catch(function () {
          return map;
        });
    }

    return next().then(function (result) {
      genreMembers[handle] = result || {};
      cards().forEach(function (card) {
        var ph = card.getAttribute("data-work-handle") || "";
        if (!ph || !genreMembers[handle][ph]) return;
        var current = cardList(card, "data-work-genres");
        if (current.indexOf(handle) === -1) {
          current.push(handle);
          card.setAttribute("data-work-genres", current.join(" "));
        }
      });
      return genreMembers[handle];
    });
  }

  function onFilterClick(event) {
    var genreBtn = event.target.closest("[data-artist-genre]");
    var tagBtn = event.target.closest("[data-artist-tag]");
    if (genreBtn && genreChips && genreChips.contains(genreBtn)) {
      activeGenre = genreBtn.getAttribute("data-artist-genre") || "";
      if (activeGenre) {
        fetchGenreMembers(activeGenre).then(apply);
      }
      apply();
      return;
    }
    if (tagBtn && tagChips && tagChips.contains(tagBtn)) {
      activeTag = tagBtn.getAttribute("data-artist-tag") || "";
      apply();
    }
  }

  if (filtersEl) filtersEl.addEventListener("click", onFilterClick);
  if (clearBtn) {
    clearBtn.addEventListener("click", function () {
      activeGenre = "";
      activeTag = "";
      activeQuery = "";
      if (filterQuery) filterQuery.value = "";
      apply();
    });
  }
  if (filterToggle) {
    filterToggle.addEventListener("click", function () {
      setFilterOpen(!filterOpen, !filterOpen);
    });
  }
  if (filterQuery) {
    filterQuery.addEventListener("input", function () {
      activeQuery = filterQuery.value.trim();
      apply();
    });
  }

  var params = readParams();
  activeGenre = params.genre;
  activeTag = params.tag;
  if (activeGenre || activeTag) setFilterOpen(true);
  rebuildFilters();
  apply();
  if (activeGenre) fetchGenreMembers(activeGenre).then(apply);

  function loadWorks() {
    if (pagedListing || !vendor) {
      rebuildFilters();
      apply();
      return;
    }
    fetchSuggest()
      .then(function (products) {
        var matched = products.filter(function (p) {
          return sameVendor(p.vendor, vendor);
        });
        if (matched.length) return matched;
        return fetchCatalogPages();
      })
      .then(function (products) {
        mergeProducts(products || []);
        rebuildFilters();
        apply();
        var pending = [];
        if (genreChips) {
          genreChips.querySelectorAll("[data-artist-genre]").forEach(function (btn) {
            var handle = btn.getAttribute("data-artist-genre");
            if (handle) pending.push(fetchGenreMembers(handle));
          });
        }
        if (!pending.length) return;
        return Promise.all(pending).then(function () {
          rebuildFilters();
          apply();
        });
      });
  }

  function initPrintLightbox() {
    if (typeof HTMLDialogElement === "undefined" || !HTMLDialogElement.prototype.showModal) return;

    var dialog = document.createElement("dialog");
    dialog.className = "artist-print-lightbox";
    dialog.setAttribute("data-artist-print-lightbox", "");
    dialog.setAttribute("aria-label", "Enlarged artwork");
    dialog.innerHTML =
      '<button type="button" class="artist-print-lightbox__close" data-artist-print-close aria-label="Close">×</button>' +
      '<div class="artist-print-lightbox__stage">' +
      '<img class="artist-print-lightbox__img" alt="" data-artist-print-img>' +
      '<button type="button" class="artist-print-lightbox__nav artist-print-lightbox__nav--prev" data-artist-print-prev aria-label="Previous artwork"><span class="artist-print-lightbox__mark" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" focusable="false"><path d="M14.25 5.25 7.5 12l6.75 6.75" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span></button>' +
      '<button type="button" class="artist-print-lightbox__nav artist-print-lightbox__nav--next" data-artist-print-next aria-label="Next artwork"><span class="artist-print-lightbox__mark" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" focusable="false"><path d="M9.75 5.25 16.5 12l-6.75 6.75" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span></button>' +
      "</div>" +
      '<div class="artist-print-lightbox__thumbs" data-artist-print-thumbs role="group" aria-label="Works in this collection"></div>' +
      '<p class="artist-print-lightbox__title" data-artist-print-title hidden></p>';
    document.body.appendChild(dialog);

    var imgEl = dialog.querySelector("[data-artist-print-img]");
    var titleEl = dialog.querySelector("[data-artist-print-title]");
    var thumbsEl = dialog.querySelector("[data-artist-print-thumbs]");
    var prevBtn = dialog.querySelector("[data-artist-print-prev]");
    var nextBtn = dialog.querySelector("[data-artist-print-next]");
    var items = [];
    var index = 0;

    function titlesOn() {
      var layout = root.querySelector(".coll-layout");
      return !(layout && layout.classList.contains("is-simplified"));
    }

    function shotFor(card) {
      var piece = card.querySelector(".card-piece[data-zoom-src]") || card.querySelector(".card-piece");
      var image = card.querySelector(".card-piece img, img");
      var titleNode = card.querySelector(".card-meta .t, .t");
      var title = (card.getAttribute("data-work-title") || (titleNode ? titleNode.textContent : "") || "").trim();
      var zoom = piece && piece.getAttribute("data-zoom-src");
      var thumb = image && (image.currentSrc || image.getAttribute("src"));
      var src = zoom || thumb;
      if (!src) return null;
      return { title: title, src: src, thumb: thumb || src, alt: (image && image.getAttribute("alt")) || title };
    }

    function collect() {
      var shots = [];
      cards().forEach(function (card) {
        if (!card.classList.contains("mcard") || card.hidden || card.classList.contains("is-dir-hidden")) return;
        var shot = shotFor(card);
        if (shot) shots.push({ card: card, shot: shot });
      });
      return shots;
    }

    function paint() {
      var entry = items[index];
      var item = entry && entry.shot;
      if (!item) return;
      imgEl.src = item.src;
      imgEl.alt = item.alt || item.title || "";
      titleEl.textContent = item.title || "";
      titleEl.hidden = !titlesOn() || !item.title;
      var many = items.length > 1;
      prevBtn.hidden = !many;
      nextBtn.hidden = !many;
      Array.prototype.forEach.call(thumbsEl.children, function (thumb, i) {
        var on = i === index;
        thumb.setAttribute("aria-current", on ? "true" : "false");
        if (on && thumb.scrollIntoView) thumb.scrollIntoView({ inline: "center", block: "nearest" });
      });
    }

    function show(next) {
      if (!items.length) return;
      index = (next + items.length) % items.length;
      paint();
      if (!dialog.open) dialog.showModal();
    }

    function openFrom(card) {
      items = collect();
      var at = 0;
      items.forEach(function (entry, i) {
        if (entry.card === card) at = i;
      });
      thumbsEl.innerHTML = "";
      items.forEach(function (entry, i) {
        var item = entry.shot;
        var button = document.createElement("button");
        button.type = "button";
        button.className = "artist-print-lightbox__thumb";
        button.setAttribute("aria-label", item.title || "Artwork");
        button.setAttribute("aria-current", "false");
        var thumb = document.createElement("img");
        thumb.src = item.thumb;
        thumb.alt = "";
        thumb.loading = "lazy";
        button.appendChild(thumb);
        button.addEventListener("click", function () {
          show(i);
        });
        thumbsEl.appendChild(button);
      });
      show(at);
    }

    root.addEventListener("click", function (event) {
      var btn = event.target.closest("[data-artist-print-enlarge]");
      if (!btn || !root.contains(btn)) return;
      var masonry = btn.closest(".masonry");
      if (!masonry || masonry.getAttribute("data-coll-frames") !== "off") return;
      var card = btn.closest(".mcard");
      if (!card) return;
      event.preventDefault();
      event.stopPropagation();
      openFrom(card);
    });

    prevBtn.addEventListener("click", function () {
      show(index - 1);
    });
    nextBtn.addEventListener("click", function () {
      show(index + 1);
    });
    dialog.querySelector("[data-artist-print-close]").addEventListener("click", function () {
      dialog.close();
    });
    dialog.addEventListener("click", function (event) {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener("keydown", function (event) {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        show(index - 1);
      } else if (event.key === "ArrowRight") {
        event.preventDefault();
        show(index + 1);
      }
    });
  }

  initPrintLightbox();
  loadWorks();
  fetchPins().then(function (pins) {
    pinnedHandles = pins;
    apply();
  });
})();
